import { useSelector } from 'react-redux';
import { AlertTitle, VStack } from '@chakra-ui/react';

import { Alert, AlertIcon, AlertDescription } from '@/components/v4';
import ChakraLink from 'components/v4/Link';
import ScopeType from '@/utils/enums/ScopeType';
import { setAlertStatusBg } from '@/utils/setAlertStatusBg';
import getRuntimeAppConfig from '@/utils/runtimeAppConfig';

const DEFAULT_MESSAGE =
    'Your account is in late payment status. Please settle your outstanding balance to avoid service disruption.';
const TITLE = 'Action required: account payment overdue.';

const WholesalerPaymentBanner = () => {
    const { requiredScope, wholesalerPaymentBanner } = useSelector(
        (state) => state.login,
    );

    const isWholesalerAdmin = requiredScope === ScopeType.WHOLESALER;
    const isBannerEnabled = Boolean(wholesalerPaymentBanner?.enabled);

    if (!isWholesalerAdmin || !isBannerEnabled) {
        return null;
    }

    const wholesalerPaymentBannerConfig =
        getRuntimeAppConfig()?.wholesalerPaymentBanner ?? {};
    const {
        status = 'error',
        title = TITLE,
        message = DEFAULT_MESSAGE,
        contactEmail,
    } = wholesalerPaymentBannerConfig;
    // Always set background colour at darkMode because of dark Navbar
    const alertBg = setAlertStatusBg(status, true);

    return (
        <Alert
            status={status}
            variant="left-accent"
            mb={2}
            sx={{
                // Override the bg prop from Alert component
                bg: alertBg,
            }}>
            <AlertIcon />
            <VStack align="start" spacing={0} flex="1">
                {title && <AlertTitle>{title}</AlertTitle>}
                <AlertDescription flex={1}>
                    {message}
                    {contactEmail && (
                        <span>
                            {' '}
                            Contact{' '}
                            <ChakraLink
                                fontWeight="bold"
                                textDecoration="none"
                                _hover={{
                                    textDecoration: 'none',
                                }}
                                _active={{
                                    textDecoration: 'none',
                                }}
                                href={`mailto:${contactEmail}`}>
                                {contactEmail}
                            </ChakraLink>{' '}
                            for assistance.
                        </span>
                    )}
                </AlertDescription>
            </VStack>
        </Alert>
    );
};

export default WholesalerPaymentBanner;
